module.exports={render:function (){with(this) {
  return _h('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_h('div', {
    staticClass: "container"
  }, [_m(0), " ", _h('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_h('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_h('router-link', {
    attrs: {
      "to": "/",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(1)]), " ", _h('li', [_m(2), " ", _h('ul', {
    staticClass: "dropdown-menu"
  }, [_h('router-link', {
    attrs: {
      "to": "/info_venue",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(3)]), " ", _h('router-link', {
    attrs: {
      "to": "/info_capetown",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(4)]), " ", _h('router-link', {
    attrs: {
      "to": "/info_2017committee",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(5)]), " ", _h('router-link', {
    attrs: {
      "to": "/info_delegateregistration",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(6)])])]), " ", _m(7), " ", _h('transition', {
    attrs: {
      "appear": "",
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.authData) ? _h('li', {
    key: "authorised"
  }, [_h('a', {
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_s(this.currentUser.forename) + " " + _s(this.currentUser.surname) + " ", (this.currentUser.type == 'administrator') ? _h('strong', ["(Admin) "]) : _e(), _m(8)]), " ", _h('ul', {
    staticClass: "dropdown-menu"
  }, [((this.authData && this.currentUser.type == 'administrator')) ? _h('router-link', {
    attrs: {
      "to": "/manageusers",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(9)]) : _e(), " ", ((this.authData && this.currentUser.type == 'administrator')) ? _h('router-link', {
    attrs: {
      "to": "/scregister",
      "tag": "li",
      "active-class": "active",
      "exact": ""
    }
  }, [_m(10)]) : _e(), " ", _h('li', [_h('a', {
    on: {
      "click": userLogout
    }
  }, ["Logout"])])])]) : _h('li', {
    key: "unauthorised"
  }, [_h('router-link', {
    attrs: {
      "to": "/login"
    }
  }, ["Login"])]), " "])])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "navbar-header"
  }, [_h('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_h('span', {
    staticClass: "sr-only"
  }, ["Toggle navigation"]), " ", _h('span', {
    staticClass: "icon-bar"
  }), " ", _h('span', {
    staticClass: "icon-bar"
  }), " ", _h('span', {
    staticClass: "icon-bar"
  })]), " ", _h('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_h('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  })])])
}},function (){with(this) {
  return _h('a', ["About us"])
}},function (){with(this) {
  return _h('a', {
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, ["Conference Info ", _h('i', {
    staticClass: "fa fa-angle-down"
  })])
}},function (){with(this) {
  return _h('a', ["About the Venue"])
}},function (){with(this) {
  return _h('a', ["About Cape Town"])
}},function (){with(this) {
  return _h('a', ["AIDSImpact 2017 Committee"])
}},function (){with(this) {
  return _h('a', ["Delegate Registration"])
}},function (){with(this) {
  return _h('li', [_h('a', {
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, ["Previous Conferences ", _h('i', {
    staticClass: "fa fa-angle-down"
  })]), " ", _h('ul', {
    staticClass: "dropdown-menu"
  }, [_h('li', [_h('a', {
    attrs: {
      "href": "2015/",
      "target": "_blank"
    }
  }, ["2015 - Amsterdam, NL"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2013/",
      "target": "_blank"
    }
  }, ["2013 - Barcelona, Spain"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2011/",
      "target": "_blank"
    }
  }, ["2011 - Santa Fe, USA"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2009/",
      "target": "_blank"
    }
  }, ["2009 - Botswana"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2007/",
      "target": "_blank"
    }
  }, ["2007 - Marseille"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2005/",
      "target": "_blank"
    }
  }, ["2005 - Cape Town"])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "2003/",
      "target": "_blank"
    }
  }, ["2003 - Milan"])])])])
}},function (){with(this) {
  return _h('i', {
    staticClass: "fa fa-angle-down"
  })
}},function (){with(this) {
  return _h('a', ["Manage Users"])
}},function (){with(this) {
  return _h('a', ["Preview Scientific Committee Registration"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerblock.vue
 ** module id = 84
 ** module chunks = 2
 **/